(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CentroDocenteDeleteController',CentroDocenteDeleteController);

    CentroDocenteDeleteController.$inject = ['$uibModalInstance', 'entity', 'CentroDocente'];

    function CentroDocenteDeleteController($uibModalInstance, entity, CentroDocente) {
        var vm = this;

        vm.centroDocente = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CentroDocente.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
